import fetchData from 'src/utils/fetchData';

export const getOrganizationsAPI = async () => {
  return fetchData('/ui/front-api/private/organizations');
};
